import { DeployEnv } from '../declarations/Observability';

export const getDeployEnv = (): DeployEnv => {
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    return 'development';
  }

  const hostname = window?.location?.hostname;
  if (hostname === undefined) {
    return 'development';
  }
  const port = window?.location?.port;
  const locationHasPort = port && port !== '';

  const onLocalhost = hostname === 'localhost';
  const onNgrok = hostname.includes('.ngrok.io');
  const onXipIO = hostname.includes('.xip.io');
  const inAndroidEmulator = hostname.includes('10.0.2.2');
  const inDevelopment = (onLocalhost && locationHasPort) || onNgrok || onXipIO || inAndroidEmulator;

  if (inDevelopment) {
    return 'development';
  }

  // In Rails CI, tests my be on a random port
  const inRailsCI = hostname === '127.0.0.1';
  // on localhost without a port corresponds to test environment
  if (inRailsCI || onLocalhost) {
    return 'test';
  }

  const onStagingManagedDomain = hostname.includes('-staging.managed.services.opendoor.com');
  const onSimplersell = hostname.includes('.simplersell.com');
  const onODMortgage = hostname.includes('.odmortgage.com');
  const inStaging = onStagingManagedDomain || onSimplersell || onODMortgage;

  const onOpendoorHomeLoans = hostname.includes('opendoorhomeloans.com');
  const onOpendoor = hostname.includes('.opendoor.com') && !hostname.includes('-staging');
  const inProduction = onOpendoor || onOpendoorHomeLoans;

  const inProdOrStaging = inStaging || inProduction;
  const onQADomain = hostname.includes('-qa-');
  const hasQACookie = document?.cookie?.includes('qa=') && document?.cookie?.includes('qa_env=');
  // most QA usage will be on a staging domain (.e.g `demo.simplersell.com`) with appropriate
  // cookies set
  const inQA = onQADomain || (inProdOrStaging && hasQACookie);

  if (inQA) {
    return 'qa';
  } else if (inStaging) {
    return 'staging';
  } else if (inProduction) {
    return 'production';
  }

  // default case
  return 'development';
};
